import { auditLogsEntryPoint } from '@jira/admin-pages__audit-logs/src/auditLogsEntryPoint.entrypoint.tsx';

import { adminPagesJsmAuditLogsRoute } from '@jira/router-routes__admin-pages-audit-logs-routes/src/adminPagesJsmAuditLogsRoute.tsx';
import { MenuIdSettings } from '@jira/navigation-apps__constants/src/MenuIdSettings.tsx';
import { SidebarIdGlobalSystemSettings } from '@jira/navigation-apps__constants/src/SidebarIdGlobalSystemSettings.tsx';
import { notFoundPageEntrypoint } from '@jira/router-routes__not-found-entrypoint/src/ui/error-pages/not-found/index.tsx';
import { navigationSidebarGlobalResource } from '@jira/router-resources__navigation-sidebar-global/src/navigationSidebarGlobalResource.tsx';
import { jiraSpaResources } from '@jira/router-resources__spa-page-container/src/jiraSpaResources.tsx';
import { getNavigationResources } from '@jira/router-resources__navigation/src/getNavigationResources.tsx';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
// eslint-disable-next-line jira/import/file-extension-required
import { createPageEntryPoint } from '@jira/platform__routing-create-route-entry-point';
import type { Route } from '@atlassian/react-resource-router/src/common/types';
import { fg } from '@atlassian/jira-feature-gating';
import { auditLogsLayout } from './auditLogsLayout.tsx';

const adminPagesJsmAuditLogsPageEntryPoint = createPageEntryPoint({
	main: auditLogsEntryPoint,
});

export const adminPagesJsmAuditLogsRouteEntry: Route = createEntry(
	adminPagesJsmAuditLogsRoute,
	() => ({
		group: 'global-settings',
		layout: auditLogsLayout,

		navigation: {
			sidebarId: SidebarIdGlobalSystemSettings,
			menuId: MenuIdSettings,
		},

		resources: [
			...getNavigationResources(),
			navigationSidebarGlobalResource,
			...jiraSpaResources(),
		],

		entryPoint: () => {
			// eslint-disable-next-line jira/ff/no-preconditioning
			return fg('jira_frontend_jsm_admin_audit_log') && fg('enable_jsm_admin')
				? adminPagesJsmAuditLogsPageEntryPoint
				: notFoundPageEntrypoint;
		},
		bifrost: {
			bifrostGroup: 'shell-only',
			bundling: {
				packageName: '@jira/router-routes__admin-pages-audit-logs-entries',
				whichExportToUse: 'adminPagesJsmAuditLogsRouteEntry',
			},
			enabled: true,
		},
	}),
);
